import { render, staticRenderFns } from "./confirm-delete-popup.vue?vue&type=template&id=b641d49a"
import script from "./confirm-delete-popup.vue?vue&type=script&lang=js"
export * from "./confirm-delete-popup.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-popup.vue?vue&type=style&index=0&id=b641d49a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports